export enum Color {
  BACKGROUND = "#171717",
  WARM_GREY = "#9F968E",
  MED_GREY = "#292929",
  ORANGE = "#FF7C1D",
  YELLOW = "#FFD37C",
  WHITE = "#E9E2DB",
}

export const API_URL = "https://tts16a99l1.execute-api.us-east-1.amazonaws.com";

export const KITCHENER = [43.4516, -80.4925];
export const DEFAULT_ZOOM = 15;
